export default __webpack_public_path__ + "static/media/blog_image.4c0be5fe.png";